module.exports = __webpack_public_path__ + "images/videoCaseStudy-results-top.svg?h=cc0efef78150670bd51ae20883f730d5";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-results-top.svg
// module id = 1480
// module chunks = 12 15